<template>
  <Head>
    <Title>Terms of Service</Title>
  </Head>
  <div class="terms-of-service">
    <h1 class="terms-of-service__heading">
      Terms of Service
    </h1>

    <p class="terms-of-service__paragraph terms-of-service__highlighted">
      PLEASE READ THESE TERMS OF SERVICE CAREFULLY
    </p>

    <p class="terms-of-service__paragraph">
      Terms and Conditions last updated on <span class=" terms-of-service__highlighted">April 12th 2024</span>
    </p>
    <p class="terms-of-service__paragraph">
      BY ACCESSING OR USING æScan SERVICES, YOU AGREE TO BE BOUND BY THESE TERMS OF SERVICE AND ALL TERMS
      INCORPORATED BY REFERENCE
    </p>

    <p class="terms-of-service__paragraph">
      These Terms of Service and any terms expressly incorporated herein (“Terms”) apply to your access to and use
      of all services (our “Services”) provided by Aeternity Foundation, Sofia district (capital), Sofia 1164, Lozenets
      district, bul. "Hristo Smirnenski" 70, info@aeternity.com, Company-Nr.: 177240621 (“Company,” “we,” or “us”).
    </p>

    <h2 class="terms-of-service__subheading">
      1. Use of æScan
    </h2>
    <p class="terms-of-service__paragraph">
      æScan is a blockchain explorer for the æternity blockchain, and it provides users with the ability to view
      information about transactions, addresses, and other data on the blockchain. By using æScan, you agree to
      comply with these terms and conditions, as well as any other policies or guidelines that may be posted on
      the site.
    </p>
    <p class="terms-of-service__paragraph">
      You may not use æScan for any illegal or unauthorized purpose, and you agree to comply with all applicable
      laws and regulations. Any violation of these terms and conditions may result in the termination of your
      access to æScan.
    </p>

    <h2 class="terms-of-service__subheading">
      2. Ownership of Content
    </h2>
    <p class="terms-of-service__paragraph">
      All content on æScan, including text, graphics, logos, and software, is the property of Aeternity
      Foundation or its licensors and is protected by copyright, trademark, and other intellectual property
      laws. You may not copy, modify, distribute, or create derivative works based on any content present on æScan
      without prior written consent.
    </p>
    <p class="terms-of-service__paragraph">
      By using æScan, you agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the
      site for any commercial purposes. You also agree not to use any robots, spiders, or other automated means to
      access or collect data from the site.
    </p>
    <p class="terms-of-service__paragraph">
      Additionally, you must not:
    </p>
    <ul class="terms-of-service__paragraph terms-of-service__list">
      <li class="terms-of-service__item">
        Use æScan in any manner that could interfere with, disrupt, negatively affect or inhibit other users
        from fully enjoying æScan, or that could damage, disable, overburden or impair the functioning of our
        Services in any manner;
      </li>
      <li class="terms-of-service__item">
        Engage in <span class="terms-of-service__highlighted">Data Collection (scraping)</span> unless such Automated
        Data Collection is confined solely to search indexing for display on the Internet.
      </li>
      <li class="terms-of-service__item">
        Engage in the reproduction of any content posted (such as public labels or name tags) or extracted
        from æScan’s APIs, CSV exports, or our website or any of our affiliate websites without our prior
        consent or authorization.
      </li>
      <li class="terms-of-service__item">
        Attempt to circumvent any content filtering techniques employed, or attempt to access any service
        or area of æScan that you are not authorized to access;
      </li>
      <li class="terms-of-service__item">
        Introduce to æScan any virus, trojan worms, logic bombs, or other harmful material;
      </li>
      <li class="terms-of-service__item">
        Provide false, inaccurate, or misleading information; and
      </li>
      <li class="terms-of-service__item">
        Encourage or induce any third party to engage in any of the activities prohibited under this Section.
      </li>
    </ul>

    <h2 class="terms-of-service__subheading">
      3. Accuracy of Information
    </h2>
    <p class="terms-of-service__paragraph">
      æScan strives to provide accurate and up-to-date information on the æternity blockchain, but there are no
      definitive guarantees as to the accuracy, completeness, or reliability of any information on the site. You
      use æScan at your own
      risk.
    </p>
    <p class="terms-of-service__paragraph">
      Aeternity Foundation is not responsible for any errors or omissions in the information on the site, or
      for any loss or damage that may arise from your use of the site or its content. You should always conduct
      your own research and verification before making any decisions based on the information provided on æScan.
    </p>

    <h2 class="terms-of-service__subheading">
      4. Limitation of Liability
    </h2>
    <p class="terms-of-service__paragraph">
      In no event shall Aeternity Foundation or its affiliates, directors, officers, employees, or agents be
      liable for any direct, indirect, incidental, special, or consequential damages arising out of or in
      connection with your use of æScan.
    </p>
    <p class="terms-of-service__paragraph">
      This includes but is not limited to, damages for loss of profits, goodwill, use, data, or other
      intangible losses resulting from your use of or inability to use the site, or from any unauthorized access
      to or alteration of your transmissions or data.
    </p>

    <h2 class="terms-of-service__subheading">
      5. Indemnification
    </h2>
    <p class="terms-of-service__paragraph">
      You agree to indemnify and hold harmless Aeternity Foundation and its affiliates, directors, officers,
      employees, and agents from and against any and all claims, liabilities, damages, losses, or expenses,
      including reasonable attorneys' fees, arising out of or in connection with your use of æScan.
    </p>
    <p class="terms-of-service__paragraph">
      This includes but is not limited to, any violation of these terms and conditions, or any infringement of any
      intellectual property or any other right of any person or entity.
    </p>

    <h2 class="terms-of-service__subheading">
      6. User-generated Content
    </h2>

    <p class="terms-of-service__paragraph">
      Responsibility regarding user-generated content - You bear sole responsibility for the content you post, upload,
      link to, or otherwise share via the service, and for any resulting harm, regardless of its form. We do not accept
      responsibility for any public display or misuse of your user-generated content. We retain the right
      (but not the obligation)
      to refuse or remove any user-generated content that, in our sole discretion, violates any æScan terms or policies.
    </p>

    <p class="terms-of-service__paragraph">
      Content ownership & posting rights - When posting content that you did not create or do not hold rights to,
      you affirm that you are accountable for it, committing to submit only content for which you have posting rights
      and to adhere fully to any third-party licenses associated with the content you post.
    </p>

    <p class="terms-of-service__paragraph">
      Grant of license to us - In order to perform actions such as hosting, publishing, and sharing your content,
      we require legal permission. Therefore, you hereby grant us and our legal successors the authority to store,
      parse, and display your content, as well as to create incidental copies as needed for website rendering
      and service provision.
    </p>

    <p class="terms-of-service__paragraph">
      Moral rights - You maintain all moral rights to your content that you upload, publish, or submit through any
      part of the service, including integrity and attribution rights. However, you waive these rights and agree
      not to enforce them against us, facilitating our reasonable exercise of the rights outlined in
      the previous section.
    </p>

    <p class="terms-of-service__paragraph">
      In instances where this agreement is not enforceable by applicable law, you grant æScan the necessary rights
      to utilize your content without attribution and to make reasonable adaptations as required for website
      rendering and service provision.
    </p>

    <p class="terms-of-service__paragraph">
      In using our services, you may view content or utilize services provided by third parties, including links
      to web pages and services of such parties. We do not control, endorse or adopt any third party content and
      will have no responsibility for third-party content, including, without limitation, material that may be
      misleading, incomplete, erroneous, offensive, indecent or otherwise objectionable in your jurisdiction.
      In addition, your business dealings or correspondence with such third parties are solely between you and
      the third parties. We are not responsible or liable for any loss or damage of any sort incurred as the
      result of any such dealings, and you understand that your use of third party content, and your
      interactions with third parties, is at your own risk.
    </p>

    <h2 class="terms-of-service__subheading">
      7. Modification of Terms and Conditions
    </h2>
    <p class="terms-of-service__paragraph">
      Aeternity Foundation reserves the right to modify these terms and conditions at any time, without prior
      notice. Your continued use of æScan following any such modification constitutes your acceptance of the
      modified terms and conditions.
    </p>
    <p class="terms-of-service__paragraph">
      You are encouraged to check this page regularly for updates to these terms and conditions.
    </p>

    <h2 class="terms-of-service__subheading">
      8. Governing Law and Jurisdiction
    </h2>
    <p class="terms-of-service__paragraph">
      These terms and conditions shall be governed by and construed in accordance with the laws of the
      Duchy of Liechtenstein, without regard to its conflicts of law principles.
    </p>
    <p class="terms-of-service__paragraph">
      Any legal action arising out of or in connection with your use of æScan shall be brought exclusively
      before the courts located in Liechtenstein.
    </p>

    <h2 class="terms-of-service__subheading">
      9. Termination of Access
    </h2>
    <p class="terms-of-service__paragraph">
      Aeternity Foundation reserves the right to terminate your access to æScan at any time, for any
      reason, without prior notice to you. In the event of such termination, these terms and conditions shall
      continue to remain in force.
    </p>

    <h2 class="terms-of-service__subheading">
      10. User Conduct
    </h2>
    <p class="terms-of-service__paragraph">
      By using æScan, you agree to conduct yourself in a responsible and lawful manner. You agree not to
      engage in any conduct that could be considered harmful, offensive, or disruptive to other users of the site
      or to the functioning of the site itself.
    </p>
    <p class="terms-of-service__paragraph">
      This includes but is not limited to, transmitting any material that is illegal, harassing,
      defamatory, or invasive of privacy, or engaging in any activity that interferes with the proper functioning
      of the site, such as spamming or hacking.
    </p>

    <h2 class="terms-of-service__subheading">
      11. Third-Party Links
    </h2>
    <p class="terms-of-service__paragraph">
      æScan may contain links to third-party websites or resources that are not owned or controlled by
      æScan. Aeternity Foundation has no control over and assumes no responsibility for the content, privacy
      policies, or practices of any third-party websites or resources.
    </p>
    <p class="terms-of-service__paragraph">
      You acknowledge and agree that Aeternity Foundation is not responsible or liable for any damage
      or loss caused or alleged to be caused by or in connection with your use of or reliance on any such content,
      goods, or services available on or through any such website or resource.
    </p>

    <h2 class="terms-of-service__subheading">
      12. Disclaimer of Warranties
    </h2>
    <p class="terms-of-service__paragraph">
      æScan is provided on an "as is" and "as available" basis, without any warranties of any kind, either
      express or implied. Aeternity Foundation makes no representations or warranties of any kind, whether
      express or implied, as to the operation of the site, the information, content, materials, or products
      included on the site, or the results that may be obtained from using the site.
    </p>
    <p class="terms-of-service__paragraph">
      Aeternity Foundation does not warrant that æScan will be uninterrupted, timely, secure, or
      error-free, nor does Aeternity Foundation make any warranty as to the accuracy, completeness, or
      reliability of any information, content, materials, or products included on the site.
    </p>

    <h2 class="terms-of-service__subheading">
      13. Entire Agreement
    </h2>
    <p class="terms-of-service__paragraph">
      These terms and conditions, together with the Privacy Policy, constitute the entire agreement
      between you and Aeternity Foundation with respect to your use of æScan, and supersede all prior or
      contemporaneous communications and proposals, whether oral or written, between you and Aeternity
      Foundation.
    </p>
  </div>
</template>

<style scoped>
.terms-of-service {
  max-width: 680px;
  margin: 0 auto;

  &__heading {
    margin-bottom: var(--space-6);
  }

  &__subheading {
    margin-bottom: var(--space-6);

    @media (--desktop ) {
      margin-bottom: var(--space-5);
    }
  }

  &__paragraph {
    margin-bottom: var(--space-5);
  }

  &__highlighted {
    font-weight: 700;
  }

  &__list {
    list-style-type: disc;
    margin-left: var(--space-2);
    font-family: var(--font-monospaced);
  }

  &__item {
    margin-bottom: var(--space-1);
  }
}
</style>
